import React, { useState } from 'react';
import Card from '../shared/Card';
import StageIndicator from './StageIndicator';
import StageOne from './StageOne';
import StageTwo from './StageTwo';
import StageThree from './StageThree';
import './IntakeForm.css';

const IntakeForm = ({ onSubmitComplete }) => {
  const [currentStage, setCurrentStage] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    kernel_text: '',
    attachment_text: null,
    provider_details: {
      name: '',
      background: '',
      experience: ''
    },
    stake: {
      amount: '',
      note: ''
    }
  });

  const handleNext = () => {
    setCurrentStage(currentStage + 1);
  };

  const handleBack = () => {
    setCurrentStage(currentStage - 1);
  };

  const handleSubmit = async (submitData) => {
    setIsSubmitting(true);
    try {
      await onSubmitComplete(submitData);
    } catch (error) {
      console.error('Submission error:', error);
      setIsSubmitting(false);
    }
  };

  const renderStage = () => {
    switch (currentStage) {
      case 1:
        return (
          <StageOne
            formData={formData}
            setFormData={setFormData}
            onNext={handleNext}
          />
        );
      case 2:
        return (
          <StageTwo
            formData={formData}
            setFormData={setFormData}
            onBack={handleBack}
            onNext={handleNext}
          />
        );
      case 3:
        return (
          <StageThree
            formData={formData}
            setFormData={setFormData}
            onBack={handleBack}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
          />
        );
      default:
        return null;
    }
  };

  const getStageTitle = () => {
    switch (currentStage) {
      case 1:
        return 'Submit Belief';
      case 2:
        return 'Provider Details';
      case 3:
        return 'Stake & Commitment';
      default:
        return '';
    }
  };

  return (
    <div className="intake-form">
      <StageIndicator currentStage={currentStage} totalStages={3} />
      <Card title={getStageTitle()}>
        {renderStage()}
      </Card>
    </div>
  );
};

export default IntakeForm;
